// One layout drives the visible cottage, walking routes and indoor weather mask.
export const HUT_ORIGIN = Object.freeze({ x: 3.0, y: 2.0, z: .9 });
export const HUT_DOOR_OUTSIDE = Object.freeze({ x: HUT_ORIGIN.x - .1, z: HUT_ORIGIN.z - 2.15 });
export const HUT_DOOR_INSIDE = Object.freeze({ x: HUT_ORIGIN.x - .1, z: HUT_ORIGIN.z - .75 });
export const HUT_APPROACH = Object.freeze({ x: HUT_ORIGIN.x, z: HUT_ORIGIN.z - 4.0 });
export const HUT_SPAWN = Object.freeze({ x: HUT_ORIGIN.x + 2.1, z: HUT_ORIGIN.z - 3.3 });
export const KITCHEN_SITE = Object.freeze({ x: HUT_ORIGIN.x - 2.55, z: HUT_ORIGIN.z - 4.4 });
export const KITCHEN_APPROACH = Object.freeze({ x: HUT_ORIGIN.x - 1.5, z: HUT_ORIGIN.z - 4.4 });
export const HUT_WALL_BOUNDS = Object.freeze({ type: 'box', x0: HUT_ORIGIN.x - 2.28, x1: HUT_ORIGIN.x + 2.28,
  z0: HUT_ORIGIN.z - 1.85, z1: HUT_ORIGIN.z + 1.85 });
export const HUT_OBSTACLES = Object.freeze([
  HUT_WALL_BOUNDS,
  { type: 'box', x0: HUT_ORIGIN.x - 1.9, x1: HUT_ORIGIN.x - .05, z0: HUT_ORIGIN.z - 3.55, z1: HUT_ORIGIN.z - 2.37 },
  { x: HUT_ORIGIN.x + .95, z: HUT_ORIGIN.z - 2.86, r: .62 },
  { x: HUT_ORIGIN.x - 1.35, z: HUT_ORIGIN.z - 3.32, r: .24 },
  { x: HUT_ORIGIN.x + 1.35, z: HUT_ORIGIN.z - 3.32, r: .24 },
]);

export function hutDoorIntent(shelter, outsideDistance = 0) {
  // The door leaf toggles indoors. Leaving is a separate, explicit action.
  if (shelter.inside) return shelter.doorOpen ? 'close' : 'open';
  return !shelter.doorOpen || outsideDistance > 1.4 ? 'approach' : 'enter';
}

export function keepHutControlsOpen(actionId, shelter) {
  return shelter.inside && ['hut-door', 'hut-close'].includes(actionId);
}

export function hutControls(shelter) {
  if (shelter.inside) return shelter.doorOpen ? [
    { id: 'hut-close', title: '关门避险', detail: '点击这里或场景中的门关门；人物留在屋内', color: '#94702f' },
    { id: 'hut-exit', title: '走出小屋', detail: '点击这里或屋外地面出屋；不会替你关门', color: '#467b77' },
  ] : [{ id: 'hut-door', title: '打开小屋门', detail: '开门后可选择出屋；点击门再次关闭', color: '#467b77' }];
  return [{ id: 'hut-door', title: shelter.doorOpen ? '进入小屋' : '走到小屋开门',
    detail: shelter.doorOpen ? '点击门进入；进屋后可点门关门'
      : '先开门，再点击门进出；进屋后关门避险', color: '#467b77' },
  ...(shelter.doorOpen ? [{ id: 'hut-close', title: '关闭小屋门',
    detail: '关闭门不会进入房屋', color: '#94702f' }] : [])];
}

export function createHutCrossing(shelter, position, entering, destination = null) {
  if (!shelter.doorOpen || shelter.inside === entering) return null;
  const end = entering ? HUT_DOOR_INSIDE : HUT_DOOR_OUTSIDE;
  return { entering, elapsed: 0, startX: position.x, startZ: position.z,
    endX: end.x, endZ: end.z, destination: entering ? null : destination };
}

export function stepHutCrossing(shelter, crossing, deltaSeconds) {
  const dt = Number.isFinite(deltaSeconds) ? Math.max(0, deltaSeconds) : 0;
  crossing.elapsed = Math.min(.85, crossing.elapsed + dt);
  const t = crossing.elapsed / .85, eased = t * t * (3 - 2 * t);
  if (t >= 1) shelter.inside = crossing.entering;
  return { x: t >= 1 ? crossing.endX : crossing.startX + (crossing.endX - crossing.startX) * eased,
    z: t >= 1 ? crossing.endZ : crossing.startZ + (crossing.endZ - crossing.startZ) * eased, done: t >= 1 };
}

export function isOutsideHut(point) {
  return point && (point.x < HUT_WALL_BOUNDS.x0 || point.x > HUT_WALL_BOUNDS.x1 || point.z < HUT_WALL_BOUNDS.z0 || point.z > HUT_WALL_BOUNDS.z1);
}
